<div class="copilotConsentPage">
  <div class="consentPanel">
    <div class="consentLogo">
      <img class="consentLogoImage" src="assets/images/frankly.png" alt="CatchHub" />
    </div>

    @if (granted) {
    <div class="consentTitle">Copilot access approved</div>

    <div class="consentLead">IntelliCatch can now use Microsoft 365 Copilot on behalf of your organisation. There is nothing else to do on this page &mdash; you can close this window.</div>

    <div class="consentNote">
      <div class="consentNoteTitle">Before your team can use it</div>
      <div class="consentNoteBody">
        Each person also needs a Microsoft 365 Copilot licence. Approving the app does not assign licences. If someone has no licence, their requests will fail while everyone else works normally.
      </div>
    </div>

    <div class="consentFootNote">You can review or withdraw this approval at any time in the Microsoft Entra admin centre, under Enterprise applications.</div>
    } @else if (retryable && autoRetrying) {
    <div class="consentTitle">Finishing approval&hellip;</div>

    <div class="consentLead">Microsoft hit a brief hiccup while registering IntelliCatch for your organisation. This clears on its own &mdash; retrying automatically, you may see one more Microsoft sign-in prompt in a moment.</div>

    <div class="consentSpinner" role="status" aria-label="Retrying"></div>
    } @else if (retryable) {
    <div class="consentTitle isError">Approval did not go through</div>

    <div class="consentLead">Microsoft hit a temporary problem while registering IntelliCatch for your organisation. This usually clears on its own &mdash; approve it again to finish.</div>

    @if (retryUrl) {
    <a class="consentRetryButton" [href]="retryUrl">Try approval again</a>
    }

    @if (errorMessage) {
    <div class="consentError" role="alert">{{ errorMessage }}</div>
    }

    <div class="consentFootNote">
      If it still fails after a few attempts, wait about 15 minutes and try once more. Still stuck? Send this message @if (errorCode) { &mdash; including the code {{ errorCode }} &mdash; } to Catch support.
    </div>
    } @else {
    <div class="consentTitle isError">Approval was not completed</div>

    <div class="consentLead">Microsoft reported a problem, so IntelliCatch has not been approved for your organisation.</div>

    @if (errorMessage) {
    <div class="consentError" role="alert">{{ errorMessage }}</div>
    }

    <div class="consentFootNote">
      Please send this message @if (errorCode) { &mdash; including the code {{ errorCode }} &mdash; } to Catch support, and we will help you finish the approval.
    </div>
    }

    <div class="consentPoweredBy">Powered by<a class="consentLink" href="https://catchsoftware.com/" target="_blank">Catch Software</a></div>
  </div>
</div>
